import {
  NEW_PROJECT,
  UPDATE_PROJECT_TITLE,
  NEW_PROJECT_DEVELOPER,
  REMOVE_PROJECT_DEVELOPER,
  REORDER_PROJECT_WEEK,
  REORDER_PROJECTS,
  MOVE_DEVELOPER_PROJECT,
  UPDATE_WEEK_NOTE,
  DROP_FIRST_COLUMN,
} from 'actions/projects';

import uuidv4 from 'uuid/v4';

export default function projectState(state = [], action) {
  switch (action.type) {
    case NEW_PROJECT:
      return [...state, action.project];
    case DROP_FIRST_COLUMN:
      return state.map(p => {
        return {
          ...p,
          weeks: [
            ...p.weeks.slice(1),
            { ...p.weeks.slice(-1)[0], id: uuidv4() },
          ],
        };
      });
    case UPDATE_PROJECT_TITLE:
      return state.map(p =>
        p.id === action.id ? { ...p, title: action.title } : p,
      );
    case NEW_PROJECT_DEVELOPER:
      return state.map(p => ({
        ...p,
        weeks: p.weeks.map(w =>
          w.id === action.weekId
            ? {
                ...w,
                developers: [
                  ...w.developers.slice(0, action.index),
                  action.developer,
                  ...w.developers.slice(action.index),
                ],
              }
            : w,
        ),
      }));
    case REMOVE_PROJECT_DEVELOPER:
      return state.map(p => ({
        ...p,
        weeks: p.weeks.map(w => ({
          ...w,
          developers: w.developers.filter(d => d.id !== action.developerId),
        })),
      }));
    case REORDER_PROJECT_WEEK:
      return state.map(p => ({
        ...p,
        weeks: p.weeks.map(w =>
          w.id === action.weekId ? { ...w, developers: action.developers } : w,
        ),
      }));
    case REORDER_PROJECTS:
      return action.projects;
    case UPDATE_WEEK_NOTE:
      return state.map(p => ({
        ...p,
        weeks: p.weeks.map(w =>
          w.id === action.weekId ? { ...w, note: action.note } : w,
        ),
      }));
    case MOVE_DEVELOPER_PROJECT:
      return state
        .map(p => ({
          ...p,
          weeks: p.weeks.map(w =>
            w.id === action.sourceWeekId
              ? {
                  ...w,
                  developers: w.developers.filter(
                    d => d.id !== action.developer.id,
                  ),
                }
              : w,
          ),
        }))
        .map(p => ({
          ...p,
          weeks: p.weeks.map(w =>
            w.id === action.destinationWeekId
              ? {
                  ...w,
                  developers: [
                    ...w.developers.slice(0, action.index),
                    action.developer,
                    ...w.developers.slice(action.index),
                  ],
                }
              : w,
          ),
        }));
    case 'RELOAD_DATA':
      return action.data.projects;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projects.js